export type AtVirtualClinicTissAAtmungsmodus =
  | '0'
  | '1'
  | '2'
  | '3'
  | '4'
  | '5';

export const AT_VIRTUAL_CLINIC_TISS_A_ATMUNGSMODUS_DISPLAY_NAMES: {
  [status in AtVirtualClinicTissAAtmungsmodus]: string;
} = {
  '0': 'Spontanatmung/nicht erhoben',
  '1': 'BIPAP',
  '2': 'CPAP',
  '3': 'Assistiert',
  '4': 'Kontrolliert',
  '5': 'HF-Beatmung',
};
